export default __webpack_public_path__ + "static/mesh-gradient-377f6c85276214baef0b74032d33907c.png";